import React from 'react';

const ContactSection = () => {
  return (
    <section className="get-form-touch" style={{ backgroundImage: 'url(assets/img/get-form-touch.png)' }}>
      <div className="container-lg inner-container">
        <div className="row">
          <div className="col-md-6 text-white">
            <h5 className="ss-1">Contact</h5>
            <h3 className="ss-2">Ready to start your growth with Our B2B Digital Marketing Service?</h3>
            <div className="home-feat-article">
              <div className="dflex-1 text-black">
                <div className="dflex-1-cnt">
                  <h6>Featured Article</h6>
                  <h5>What is good conversion rate?</h5>
                </div>
                <div className="dflex-1-icon">
                  <img src="assets/img/peop-1.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 text-white">
            <h6 className="ss-3">Your success story begins here. Connect with us today!</h6>
            <p>Are you ready to start elevating your brand and getting results? Then stop reading and start typing! Fill out the form and let’s begin…</p>
            <div className="row">
              <div className="col-xl-10">
                <div className="contact-hubspot-from-fix hubspot-label-none">
                  <script charSet="utf-8" type="text/javascript" src="//js.hsforms.net/forms/embed/v2.js"></script>
                  <script dangerouslySetInnerHTML={{
                    __html: `
                      hbspt.forms.create({
                        region: "na1",
                        portalId: "20163966",
                        formId: "8175daf0-ba29-4864-9aac-92ad01c20e8c"
                      });
                    `
                  }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
